import { IBox } from './exportLabelTypes'

// The StruxHub logo at the mapbox wordmark's width, on a plate that keeps it legible over
// satellite imagery. Fixed in layout px, so every paper, quality and format carries the same mark;
// `scale` only grows it with the credits for a sheet read from further away.
const LOGO_ARTWORK = { width: 117, height: 32 }
const LOGO_WIDTH_PX = 88
const WATERMARK_LOGO = {
  width: LOGO_WIDTH_PX,
  height: (LOGO_WIDTH_PX * LOGO_ARTWORK.height) / LOGO_ARTWORK.width,
}
const WATERMARK_PLATE_PADDING_PX = 5
const WATERMARK_INSET_PX = 10

export interface IExportWatermark {
  plate: IBox
  logo: IBox
}

export function exportWatermark(scale: number): IExportWatermark {
  const padding = WATERMARK_PLATE_PADDING_PX * scale
  const logo = {
    x: WATERMARK_INSET_PX + padding,
    y: WATERMARK_INSET_PX + padding,
    width: WATERMARK_LOGO.width * scale,
    height: WATERMARK_LOGO.height * scale,
  }
  return {
    plate: {
      x: WATERMARK_INSET_PX,
      y: WATERMARK_INSET_PX,
      width: logo.width + 2 * padding,
      height: logo.height + 2 * padding,
    },
    logo,
  }
}
